// 489850 - documentos de cartão parcelado retornam duas ocorrências com o mesmo Codigo na
// resposta de ObterDadosParaInsercaoEdicaoParcela: uma faceta à vista (TipoParcela = 0) e uma
// a prazo (TipoParcela = 2). Selecionar apenas por Codigo pega a primeira ocorrência da lista e
// pode tratar um crédito parcelado como à vista (dependendo da ordem de retorno da API).
// O predicado abaixo escolhe a faceta cujo TipoParcela corresponde ao Tipo da parcela
// selecionado, sem depender da ordem.

export const tipoDocumentoCorrespondeAoTipoParcela = (
  tipoDocumento: { TipoParcela?: number },
  tipoParcela: number
): boolean =>
  (tipoParcela == 2 && tipoDocumento.TipoParcela == 2) ||
  (tipoParcela != 2 && tipoDocumento.TipoParcela != 2);

export const encontrarTipoDocumentoPorTipoParcela = <T extends { Codigo?: number; TipoParcela?: number }>(
  tiposDocumento: T[],
  codigo: number,
  tipoParcela: number
): T | undefined =>
  (tiposDocumento ?? []).find(
    (tipoDocumento) =>
      tipoDocumento.Codigo == codigo &&
      tipoDocumentoCorrespondeAoTipoParcela(tipoDocumento, tipoParcela)
  );
